import classNames from 'classnames'
import { useSelector } from 'react-redux'

import { isGettingStartedComplete } from './gettingStartedSteps'
import CoachProfileCard from './CoachProfileCard'
import GettingStarted from './GettingStarted'
import AllSetCard from './AllSetCard'

import classes from './PortalHomePage.module.scss'

const PortalHomePage = () => {
  const user = useSelector(state => state.user.current_user)

  return (
    <main className={classes.page}>
      <div className={classNames('d-flex flex-column', classes.sideColumn)}>
        <CoachProfileCard coach={user} />
      </div>
      <div className={classNames('d-flex flex-column', classes.mainColumn)}>
        {isGettingStartedComplete(user) ? <AllSetCard coach={user} /> : <GettingStarted coach={user} />}
      </div>
    </main>
  )
}

export default PortalHomePage
